import { render, staticRenderFns } from "./trusteeshipList.vue?vue&type=template&id=ee3ecf60&scoped=true"
import script from "./trusteeshipList.vue?vue&type=script&lang=js"
export * from "./trusteeshipList.vue?vue&type=script&lang=js"
import style0 from "./trusteeshipList.vue?vue&type=style&index=0&id=ee3ecf60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3ecf60",
  null
  
)

export default component.exports